import { useMemo } from 'react'

import { useQuery } from 'react-query'

import { type DetailedUser } from '@webapp/platform/iam/entities/DetailedUser'
import { UserPurchasePriceLimit } from '@webapp/platform/iam/entities/UserPurchasePriceLimit'
import { userQueryConfig } from '@webapp/platform/iam/query-configs/user'

type UseQueryUserPurchasePriceLimitReturn = {
  data: {
    purchasePriceLimit: UserPurchasePriceLimit
  }
  states: {
    isFetching: boolean
  }
}

export const useQueryUserPurchasePriceLimit = ({
  userId,
}: {
  userId: DetailedUser['id']
}): UseQueryUserPurchasePriceLimitReturn => {
  const { data, isFetching } = useQuery(
    userQueryConfig.getPurchasePriceLimit(userId)
  )

  const { purchasePriceLimit } = useMemo(() => {
    if (!data) return { purchasePriceLimit: undefined }
    return {
      purchasePriceLimit: new UserPurchasePriceLimit(data.data),
    }
  }, [data])

  return {
    data: { purchasePriceLimit },
    states: { isFetching },
  }
}
